import { ShiftRecord } from 'src/shared/models/shift-record.model';
import { RoomAcuityRecord } from 'src/shared/models/room-acuity-record.model';
import { Room } from 'src/shared/models/room.model';
import { AncillaryConfiguration } from 'src/shared/models/ancillary-configuration.model';
import { UntypedFormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';
import { AcuityCensusRecord } from 'src/shared/models/acuity-census-record.model';


@Injectable({
    providedIn: 'root'
  })
export class AcuityRoomsUtility {
    
    getRoomControlName(roomId: number) {
        return 'room' + roomId;
    }

    getRoomAcuity(shiftRecord: ShiftRecord, room: Room) : RoomAcuityRecord {
        if (!shiftRecord.roomAcuityRecords) {
            shiftRecord.roomAcuityRecords = [];
        }
        let existingRecord = shiftRecord.roomAcuityRecords.find(x => x.roomId == room.id);
        if (existingRecord) {
            return existingRecord;
        } else {
            let newRecord = new RoomAcuityRecord();
            newRecord.roomId = room.id;
            newRecord.shiftRecordId = shiftRecord.id;
            shiftRecord.roomAcuityRecords.push(newRecord);
            return newRecord;
        }
    }
  
    setRoomAcuities(ancillaryConfiguration: AncillaryConfiguration, shiftRecord: ShiftRecord, form: UntypedFormGroup) {        
        ancillaryConfiguration.roomTypes.forEach(roomType => {
            roomType.rooms.forEach(room => {
                let roomAcuityRecord = this.getRoomAcuity(shiftRecord, room);
                let controlValue = form.value[this.getRoomControlName(room.id)];   
                
                if (controlValue == 'vacant') {
                    roomAcuityRecord.isVacant = true;
                    roomAcuityRecord.acuityCategoryId = null;
                } else if (!controlValue || controlValue.value == '') {
                    roomAcuityRecord.isVacant = false;
                    roomAcuityRecord.acuityCategoryId = null;
                } else {
                    roomAcuityRecord.isVacant = false;
                    roomAcuityRecord.acuityCategoryId = controlValue;
                }
            });
        });
    }

    populateRoomAcuityValues(ancillaryConfiguration: AncillaryConfiguration, shiftRecord: ShiftRecord, form: UntypedFormGroup): Map<string, number> {
        if (shiftRecord && shiftRecord.roomAcuityRecords && shiftRecord.roomAcuityRecords.length > 0) {           
           
            let acuityCount = this.initializeAcuityCounts(ancillaryConfiguration);
            
            ancillaryConfiguration.roomTypes.forEach(roomType => {
                roomType.rooms.forEach(room => {
                    let roomAcuityRecord = shiftRecord.roomAcuityRecords.find(x => x.roomId == room.id);
                    if (roomAcuityRecord) {
                        let control =  form.get(this.getRoomControlName(room.id));
                        if (roomAcuityRecord.isVacant) {
                            control.setValue("vacant");
                        } else {                            
                            control.setValue(roomAcuityRecord.acuityCategoryId);
                            let currentValue = acuityCount.get(roomAcuityRecord.acuityCategoryId.toString());
                            currentValue = currentValue + 1;
                            acuityCount.set(roomAcuityRecord.acuityCategoryId.toString(), currentValue);
                        }
                    }                    
                });            
            });
            return acuityCount;
        }
    }

    createAcuityCensusRecords(acuityCount: Map<string, number>, shiftRecord: ShiftRecord) {
      let snapshots = [];
      
        acuityCount.forEach((value, key, map)  => {
            let snapshot = new AcuityCensusRecord();
            if (!isNaN(+key)) {
                snapshot.acuityCategoryId = +key;
                snapshot.patients = value;
                snapshot.shiftRecordId = shiftRecord.id;
                snapshots.push(snapshot);
            }            
        });
        return snapshots;
    }

    updateAcuityTotal(values: any, ancillaryConfiguration: AncillaryConfiguration): Map<string, number> {
      let acuityCount = this.initializeAcuityCounts(ancillaryConfiguration);

         ancillaryConfiguration.roomTypes.forEach(roomType => {
             roomType.rooms.forEach(room => {
                 let acuityCategoryId = +values[this.getRoomControlName(room.id)];
                 if (acuityCategoryId != 0) {
                     let currentValue = acuityCount.get(acuityCategoryId.toString());
                     currentValue = currentValue + 1;
                     acuityCount.set(acuityCategoryId.toString(), currentValue);
                 }               
             });       
         });
         return acuityCount;
     }
     
     private initializeAcuityCounts(ancillaryConfiguration: AncillaryConfiguration): Map<string, number> {
         let acuityCount = new Map<string, number>();
         acuityCount.set("vacant", 0); // Vacant
         let acuityCategories= ancillaryConfiguration.acuityCategories.length == 0 ?
                 ancillaryConfiguration.lastInactivatedAcuityCategories :  ancillaryConfiguration.acuityCategories;

         acuityCategories.forEach(category =>{
             acuityCount.set(category.id.toString(), 0);
         });
         return acuityCount;
     }
}
